// extracted by mini-css-extract-plugin
export var brand = "_48-9";
export var button = "_48-0";
export var chevron = "_48-v";
export var chevronButton = "_48-w";
export var content = "_48-n";
export var danger = "_48-g";
export var dangerOutlined = "_48-h";
export var dark = "_48-l";
export var darkTheme = "_48-c";
export var extraSmall = "_48-4";
export var fullWidth = "_48-8";
export var ghost = "_48-d";
export var gray = "_48-t";
export var icon = "_48-p";
export var iconButton = "_48-s";
export var iconButtonBorder = "_48-x";
export var iconButtonBorderDark = "_48-y";
export var iconButtonBorderLight = "_48-z";
export var iconLeft = "_48-q";
export var iconRight = "_48-r";
export var large = "_48-1";
export var light = "_48-m";
export var medium = "_48-2";
export var micro = "_48-5";
export var nano = "_48-7";
export var outlined = "_48-k";
export var pending = "_48-a";
export var primary = "_48-i";
export var shadow = "_48-o";
export var small = "_48-3";
export var solidLight = "_48-e";
export var solidLightBrand = "_48-f";
export var spinner = "_48-u";
export var transparent = "_48-j";
export var warning = "_48-b";
export var wideNano = "_48-6";